export default __webpack_public_path__ + "static/media/vendor-logo-white.6ec7adcc.svg";